import { config, axiosCall, MethodType } from "@/apis/base";
import { $s } from "@/helpers/settings.js";
import store from "@/store";

/**
 * Performs a preflight check and prepares the payload for API calls.
 *
 * @param {Object} payload - The payload for the API request.
 * @returns {Object|undefined} - The modified payload or undefined if preflight fails.
 */
function preflight(payload = {}) {
  if (!config.baseApiUrl) {
    console.error("[API] Base API URL is not set.");
    return false;
  }

  if (!$s("useAuth")) {
    console.warn("[Datastore] Auth disabled.");
    return false;
  }

  if (!$s("useDatastore")) {
    console.warn("[Datastore] Use datastore disabled.");
    return false;
  }

  if (!$s("publicKey")) {
    console.warn("[Datastore] Missing public_key");
    return false;
  }

  if (!store.getters.getToken) {
    console.error("[Datastore] Missing token");
    return false;
  }

  return payload;
}

function readEntry() {
  if (!preflight()) {
    return Promise.reject(new Error("Preflight failed"));
  }

  let url = config.datastore.entry;

  return axiosCall(MethodType.GET, url);
}

function readEntries() {
  if (!preflight()) {
    return Promise.reject(new Error("Preflight failed"));
  }

  let url = config.datastore.entries;

  return axiosCall(MethodType.GET, url);
}

export { readEntry, readEntries };
